export default "__VITE_ASSET__6d572049__"